import { lazy, Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import HeroSection from './components/HeroSection';
import HomeSchemaMarkup from './components/HomeSchemaMarkup';

/**
 * All below-fold sections live in one lazy chunk.
 * The hero + navbar paint immediately; everything else loads after first interaction.
 */
const HomeBelowFold = lazy(() => import('./components/HomeBelowFold'));

export default function Home() {
  return (
    <main className="bg-ds-bg min-h-screen font-body">
      <HomeSchemaMarkup />
      <Navbar />
      <HeroSection />
      <Suspense fallback={null}>
        <HomeBelowFold />
      </Suspense>
    </main>
  );
}
